export default class TabsSection {
    constructor($element) {
        this.$element = $element;

        this.bindEvents();
    }

    bindEvents() {
        let me = this;

        this.$element.on('click', '.js-tab', function () {
            me.updateTab($(this).attr('data-tab'));
            return false;
        });
    }

    getActiveTab() {
        return this.$element.find('.tabs__link--active').attr('data-tab');
    }

    updateTab(tab) {
        if (tab === this.getActiveTab()) {
            return;
        }

        this.$element.find('.js-tab').removeClass('tabs__link--active');
        this.$element.find('.js-tab[data-tab="' + tab + '"]').addClass('tabs__link--active');

        this.$element.find('.js-tab-content').removeClass('tab-content__section--active');
        this.$element.find('.js-tab-content[data-tab="' + tab + '"]').addClass('tab-content__section--active');
    }
}
